<template>
  <main>
    <section-hero :bgImg="bgImg" :subtitle="subtitle"></section-hero>
    <section class="section--scientist" id="scrollToOnLoad">
      <b-container>
        <b-row>
          <b-col sm="6" lg="5" offset-lg="1"
            class="d-flex flex-column justify-content-center order-2 order-sm-1">
            <h2 class="pt-lg-0 mt-5 mt-md-4">{{ content.title }}
              <span class="text--shadow-right">{{ content.title }}</span></h2>
            <p class="scientist__questions text-center" v-html="content.questions"></p>
            <p class="scientist__text" v-html="content.content"></p>
          </b-col>
          <b-col sm="6" lg="5" offset-lg="1" class="order-1 order-sm-2">
            <div
              v-if="scientists.length"
              class="d-flex justify-content-center justify-content-sm-between flex-wrap">
              <div class="scientist mb-2" v-for="(scientist, index) in scientists" :key="index">
                <img class="scientist__img  img-fluid" :src="domain + scientist.photo.url">
                <div
                class="scientist__content d-flex flex-column justify-content-between text-center">
                  <div class="mt-4">
                    <span class="scientist__name">
                      {{ scientist.first_name }} {{ scientist.last_name }}
                    </span>
                    <p class="text--small text--white">
                      {{ scientist.position }}, {{ scientist.school }}
                    </p>
                  </div>
                  <ul class="scientist__social-media mb-3">
                    <li><a :href="scientist.linkedin_url" target="_blank">
                      <i class="fab fa-linkedin"></i></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section class="section--ask-question" id="ask-question">
      <b-container>
        <b-row>
          <b-col cols="12" md="5" offset-md="0" offset-lg="1" class="text-center">
              <img class="question__img" src="@/assets/ico-person.svg" alt="">
          </b-col>
          <b-col md="6" class="mt-5 mt-sm-3 mt-md-0">
              <h1 class="text--black">{{ $t("askScientist.askQuestion") }}</h1>
              <p class="mt-lg-2 mb-4 mb-md-2 mb-lg-4">{{ $t("askScientist.title") }}</p>
              <b-form @submit.prevent="askQuestion">
                <b-form-input
                  type="text" v-model="user.question"
                  required placeholder="Ask a questions..." class="mb-3">
                </b-form-input>
                <b-btn class="mt-5 mt-sm-1 d-block mx-auto mx-sm-0 float-sm-right"
                  variant="primary"
                  :disabled="user.question.trim().length === 0"
                  size="sm"
                  type="submit">
                    {{ $t("send")}}
                </b-btn>
              </b-form>
          </b-col>
        </b-row>
      </b-container>
    </section>
    <section-discussion v-for="(discussion, index) in discussions"
    :discussion="discussion" :key="index">
    </section-discussion>
    <section-support></section-support>
  </main>
</template>

<script>
import auth from '@/api/v1/auth';
import scientist from '@/api/v1/askScientis';
import questions from '@/api/v1/questions';
import Hero from '@/components/Hero';
import Support from '@/components/Support/Index';
import Discussion from '@/views/AskScientist/Discussion';

export default {
  components: {
    'section-hero': Hero,
    'section-support': Support,
    'section-discussion': Discussion,
  },
  data() {
    return {
      bgImg: 'Banner1-I_Love_Science-',
      subtitle: this.$t('nav.iLoveScience'),
      domain: process.env.SERVER_URL,
      scientists: [],
      content: {},
      user: {
        question: '',
      },
      discussions: [],
    };
  },
  methods: {
    askQuestion() {
      if (auth.user.authenticated) {
        const succ = () => {
          this.user.question = '';
        };
        questions.add(this.user, succ);
      } else {
        sessionStorage.setItem('Redirect-after-login', 'ask_a_scientist/#ask-question');
        this.$router.push({ name: 'login' });
      }
    },
    getDiscussion() {
      const succ = (response) => { this.discussions = response.data.scientific_questions; };
      questions.index(succ);
    },
    getContent() {
      const succ = (response) => {
        this.content = response.data.our_scientists;
        this.scientists = response.data.our_scientists.scientists;
      };
      scientist.index(succ);
    },
  },
  created() {
    this.getContent();
    this.getDiscussion();
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section{
  &--scientist {
    padding-bottom: 100px;
    padding-top: 100px;
    @include media('<md') {
      padding: 50px 0;
    }
  }
  &--ask-question {
    background-color: $color--gray-4;
    padding-top: 80px;
    padding-bottom: 30px;
    @include media('<md') {
      padding: 40px 0;
    }
  }
}
.scientist {
  position: relative;
  width: 225px;
  height: 190px;
  @include media('<xl') {
    width: 180px;
    height: 165px;
  }
   @include media('<lg') {
      width: 118px;
      height: 99px;
    }
  &:hover {
    .scientist__content {
    opacity: 1;
    }
  }
  &__text {
    font-size: 16px;
    padding-top: 40px;
    line-height: 20px;
    @include media('<md') {
      padding-top: 15px;
    }
  }
  &__questions {
    font-size: 16px;
    font-style: italic;
    padding-top: 40px;
    max-width: 260px;
    margin: 0 auto;
  }
  &__name {
    font-size: 20px;
    font-weight: 800;
  }
  &__content {
    opacity: 0;
    position: absolute;
    top: 0;
    left: 0;
    background-color: $color--orange;
    width: 100%;
    height: 100%;
    transition: opacity 0.5s ease;
  }
  &__social-media {
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    svg {
      height: 25px;
      width: auto;
    }
  }
}
.question {
  &__img {
    width: 300px;
    height: auto;
    @include media('<lg') {
      width: 180px;
    }
    @include media('<md') {
      width: 200px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AskScientist/Index.vue